// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__lDf3U","subheader":"ReorderModal_subheader__1sZlx","listWrap":"ReorderModal_listWrap__2hqcR"};